export enum CompanyContentBlock {
  Root = 'CompanyContent',
}

export enum CompanyContentElement {
  Navigation = 'navigation',
  Content = 'content',
}
